var React = require('react');

function CubeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 59L1 1L59 1L59 59L1 59Z","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M58.7998 1.20117L1.01172 58.9893","strokeMiterlimit":"10","key":1})]);
}

CubeInline.defaultProps = {"viewBox":"0 0 60 60","fill":"none"};

module.exports = CubeInline;

CubeInline.default = CubeInline;
